import React, { useEffect } from 'react'; 
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'swiper/css';
import './ServiceableCities.css';

const cities = [
  {
    title: 'Car Rental In Chandigarh',
    address: 'SCO 34A Parking, Near DHL office, Chandigarh 160022',
    image: '/assets/chandigarh.png',
  },
  {
    title: 'Car Rental In Dehradun',
    address: 'MDDA Comlpex Parking, Clock Tower, Dehradun 248001',
    image: '/assets/dehradun.png',
  },
  {
    title: 'Car Rental In Amritsar',
    address: 'S404 Basant Avenue, Near Rajender Public School Amritsar 143001',
    image: '/assets/amritsar.png',
  },
  {
    title: 'Car Rental In Bengaluru',
    address: 'CV Raman Circle, Amruthahalli Main Rd, Bengaluru, Karnataka 560092',
    image: '/assets/bengaluru.png',
  },
];

const ServiceableCities = () => {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100, once: true });
  }, []);

  return (
    <section className="bg-dark text-light mt-2 py-5">
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="fw-bold fontgeorgio">Serviceable Cities</h2>
          </div>
        </div>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
        >
          {cities.map((city, index) => (
            <SwiperSlide key={index}>
              <div
                className="city-card rounded-4 overflow-hidden position-relative"
                data-aos="fade-up"
                data-aos-delay={`${index * 100}`}
              >
                <img
                  src={city.image}
                  alt={city.title}
                  className="w-100 h-100 object-fit-cover city-card-img"
                />
                <div className="city-card-overlay p-3 d-flex flex-column justify-content-end">
                  <h5 className="fw-bold">{city.title}</h5>
                  <div className="underline mb-2"></div>
                  <p className="mb-0">{city.address}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default ServiceableCities;
